import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import SkipLink from "./SkipLink";
import CookieBanner from "./CookieBanner";

export const Layout = ({ children }) => (
    <>
        <SkipLink />
        <Header />
        <main id="main-content" tabIndex="-1" data-testid="main-content">
            {children}
        </main>
        <Footer />
        <CookieBanner />
    </>
);

export default Layout;
